import React from "react";
import { Trans } from "react-i18next";

import {
  Callout,
  Checkbox,
  FormGroup,
  Icon,
  NumericInput,
  Tag,
} from "@blueprintjs/core";
import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../../utils/AuthenticatedFetch";

function CharMatching(props) {
  return (
    <FormGroup
      label={
        <span>
          <Tag>
            <pre>{props.char}</pre>
          </Tag>
          <Icon icon="equals" />
          <Tag>
            <pre>{props.match}</pre>
          </Tag>
        </span>
      }
      labelFor={"cm" + props.id}
      inline={true}
    >
      <Checkbox
        id={"cm" + props.id}
        checked={props.enabled}
        onClick={() => {
          props.onChange({ ...props, enabled: !props.enabled });
        }}
      />
    </FormGroup>
  );
}

export default function CharMatchings(props) {
  const [rules, setRules] = React.useState([]);
  const [minplatesize, setMinplatesize] = React.useState(undefined);

  function update() {
    authenticatedGetFetch("/ow/dc/settings/charmatchings?srv=" + props.srv, (res) => {
      setRules(res);
      authenticatedGetFetch("/ow/dc/settings/minplatesize?srv=" + props.srv, (res) => {
        setMinplatesize(res);
      });
    });
  }

  React.useEffect(() => {
    update();
  }, [props.srv]);

  return (
    <span>
      <Callout title={<Trans>char matching</Trans>}>
        {rules.map((rule) => (
          <CharMatching
            key={"cm" + rule.id}
            {...rule}
            onChange={(data) =>
              authenticatedPostFetch("/ow/dc/settings/charmatching?srv=" + props.srv, data, () =>
                update()
              )
            }
          />
        ))}
      </Callout>
      <br />
      <Callout title={<Trans>plate validation</Trans>}>
        {minplatesize !== undefined && (
          <FormGroup
            label={<Trans>minimum plate len</Trans>}
            labelFor={"plateminsize"}
            inline={true}
          >
            <NumericInput
              defaultValue={minplatesize}
              id="plateminsize"
              min={1}
              max={10}
              maxLength={2}
              onValueChange={(value) => {
                authenticatedPostFetch(
                  "/ow/dc/settings/minplatesize?srv=" + props.srv,
                  value,
                  () => update()
                );
              }}
            />
          </FormGroup>
        )}
      </Callout>
    </span>
  );
}
